document.addEventListener("DOMContentLoaded", function () {
  const dropdowns = document.querySelectorAll("#quantity-dropdown");
  const hiddenInputs = document.querySelectorAll("quantity-selector-component input");
  const qtyWrappers = document.querySelectorAll(".quantity-selector");
  const customWrappers = document.querySelectorAll(".custom-dropdown-wrapper");

  function syncQuantity(value) {
    hiddenInputs.forEach(input => (input.value = value));
    dropdowns.forEach(dd => {
      const span = dd.querySelector(".selected span");
      if (span) span.innerText = value;
    });
    document.querySelectorAll(".custom-dropdown-wrapper input").forEach(inp => {
      inp.value = value;
    });
  }

  dropdowns.forEach((dropdown, index) => {
    const selected = dropdown.querySelector(".selected span");
    const list = dropdown.querySelector(".dropdown-list");
    const hiddenInput = hiddenInputs[index];
    const qtyWrapper = qtyWrappers[index];
    const customWrapper = customWrappers[index];

    dropdown.addEventListener("click", () => {
      list.classList.toggle("hidden");
    });

    list.querySelectorAll("li").forEach(item => {
      item.addEventListener("click", () => {
        const value = item.getAttribute("data-value");

        if (value === "custom") {
          customWrappers.forEach((cw, i) => {
            cw.classList.add("show-input");
            dropdowns[i].classList.add("hidden");
            hiddenInputs[i].value = 10;
            qtyWrappers[i].classList.remove("hidden");
          });
          syncQuantity(10);
        } else {
          syncQuantity(value);
        }
        list.classList.add("hidden hideInput");
      });
    });

    document.addEventListener("click", (e) => {
      if (!dropdown.contains(e.target)) {
        list.classList.add("hidden");
      }
    });
  });

  document.querySelectorAll(".custom-dropdown-wrapper input").forEach(inp => {
    inp.addEventListener("input", () => {
      if (inp.value && !isNaN(inp.value)) {
        syncQuantity(inp.value);
      }
    });
  });
});


$(document).ready(function () {
  let $slider = $('.key-ingredients .slides');
  let slideCount = $slider.children().length;
  $('.key-ingredients .slides').on('init reInit afterChange', function(event, slick, currentSlide){
    let index = currentSlide !== undefined ? currentSlide : 0;
    let $currentSlider = $(slick.$slider); // current slider container

    // Find current slide's image height in this slider only
    let $currentSlide = $(slick.$slides[index]);
    let imageHeight = $currentSlide.find('img').height();

    // Limit arrow selection to this slider instance only
    $currentSlider.find('.slick-prev, .slick-next').css('top', (imageHeight / 2) + 'px');
  }).slick({
    draggable: true,
    swipeToSlide: true,
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 4000,
    slidesToShow: slideCount >= 2 ? 2 : 1,
    slidesToScroll: 1,
    cssEase: 'linear',
    responsive: [
    {
      breakpoint: 750,
      settings: {
        slidesToShow: slideCount >= 2 ? 2 : 1,
        slidesToScroll: 1,
        arrows: false,
      }
    }
  ]
  });
  $('.flexslider2:not(.key-ingredients-list) .slides').slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#fff" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#fff" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>'
  }); 
  $('.ingredients-list-button[data-fancybox]').fancybox({
    afterShow: function () {
      if ($('.flexslider2.key-ingredients-list .slides').hasClass('slick-initialized')) {
        $('.flexslider2.key-ingredients-list .slides').slick('unslick');
      }
      $('.flexslider2.key-ingredients-list .slides').slick({
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        infinite: true,
        dots: true,
        arrows: true,
        prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#fff" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path fill="#fff" d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>'
      }); 
    }
  });

  var acc = document.getElementsByClassName("accordion");
  var panel = document.getElementsByClassName('panel');
  for (var i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      this.classList.toggle("active");
      this.nextElementSibling?.classList?.toggle("show");
    }
  }
});

$(function () {
  $(".chooseCurlType-dropdown-container").on("click", function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  });

  $(".chooseCurlType-dropdown-btn").bind("click", function(e) {
    e.preventDefault();
    
    $(".chooseCurlType-dropdown").hide();
    $(".product-card").removeClass("show-chooseCurlType-option");

    var parent = $(this).parents("product-form-component");
    parent.find(".chooseCurlType-dropdown").css("display","block");
    $(this).parents(".product-card").addClass("show-chooseCurlType-option");       
  });
  
  $(".chooseCurlType-dropdown li").bind("click", function(e) {
    e.preventDefault();

    var parent = $(this).parents("product-form-component");
    var productID = $(this).data("var-id");
    var text = $(this).text();
    
    parent.find(".chooseCurlType-dropdown").css("display","none");
    parent.find(".upside-ucd-cart-form [name='id']").val(productID);
    
    parent.find(".upside-ucd-cart-form").addClass("showing").css({"height":"auto"});
    parent.find(".chooseCurlType-dropdown-btn span").html(text);

    if($(this).hasClass("variableProduct")){
      var productParent = $(this).parents(".product-item");
      var productPrice = productParent.find("#variant-price-"+productID);
      var productImg = productParent.find("#variableProduct-img-"+productID);

      if(productPrice.length){
        productParent.find(".price").text(productPrice.text());
      }
      
      if(productImg.length){
        productParent.find("[id *='variableProduct-img']").removeClass("selected").hide();
        productParent.find(".product-item__primary-image").hide();
        productImg.addClass("selected").show();
      } else {
        productParent.find("#sold-out-btn-"+productID).hide();
        productParent.find(".add-to-cart-btn-collection:not(#sold-out-btn-"+productID+")").show();
      }
    }
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".chooseCurlType-dropdown-container").length) {
      $(".chooseCurlType-dropdown").hide();
      $(".product-card").removeClass("show-chooseCurlType-option");
    }
  }); 
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".read-more-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const targetId = btn.getAttribute("data-target");
      const content = document.querySelector(`[data-block-id="${targetId}"]`);
      if (content) {
        content.classList.toggle("expanded");
        btn.textContent = content.classList.contains("expanded") ? "Read less" : "Read more";
      }
    });
  });
});

$(document).ready(function() {
    $('[title="/pages/lus-policies"]').on("click", function(e) {
      e.preventDefault();
      window._klOnsite = window._klOnsite || []; 
      window._klOnsite.push(['closeForm']);
		  window._klOnsite.push(['openForm', 'TGUvhc']);
    });

    $('.scroll-to').click(function(){
          var target = $(this).data("target");
          $(".product-tabs .accordion-item:first-of-type .accordion-toggle").addClass('active');
            $(".product-tabs .accordion-item:first-of-type .accordion-content").addClass('show');
            $('html, body').stop().delay(300).animate({
                'scrollTop': $(target).offset().top 
            }, 300, 'swing');
         });
});